const PLATFORM_LABELS: Record<string, string> = {
    Twitter: "X (Twitter)",
    Google: "Google Business Profile",
};

export const platformLabel = (key: string): string => PLATFORM_LABELS[key] ?? key;

export const postTypeLabel = (key: string): string => key;

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Dates arrive as yyyy-MM-dd already computed in the user's timezone by the
// api; format them as text, never through Date, so the browser zone cannot
// shift a day.
const parts = (iso: string): { y: number; m: number; d: number } => {
    const [y, m, d] = iso.split("-").map(Number);
    return { y, m, d };
};

export const formatShortDate = (iso: string): string => {
    const { m, d } = parts(iso);
    return `${MONTHS[m - 1]} ${d}`;
};

export const formatRange = (start: string, end: string): string => {
    const s = parts(start);
    const e = parts(end);
    if (s.y === e.y) return `${formatShortDate(start)} - ${formatShortDate(end)}, ${e.y}`;
    return `${formatShortDate(start)}, ${s.y} - ${formatShortDate(end)}, ${e.y}`;
};

export const formatPublishedAt = (isoInstant: string, timeZone: string): string =>
    new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        timeZone,
    }).format(new Date(isoInstant));
